import { Dispatch, SetStateAction } from "react";
import { BatchedDocumentsItemMap } from "../types";
import { DOCUMENT_SIGNING_STAGES } from "../constants";
import { signDocumentsCertificate } from "./sign-documents-certificate";
import { processError } from "./process-error";

export const localSigningDocuments = async (
  setError: Dispatch<SetStateAction<string>>,
  certificateId?: string,
  batch?: BatchedDocumentsItemMap
) => {
  if (!batch || !certificateId) {
    return {};
  }

  const hasCcbFiltered = Object.values(batch).filter(
    (document) =>
      document.isSigningAvailable &&
      document.signatureInfo.signingStage === DOCUMENT_SIGNING_STAGES.GOT_CCB &&
      !document.signatureInfo.signature &&
      !document.signingUnavailableReasonText
  );

  if (!hasCcbFiltered.length) {
    return;
  }

  const hasCcb = hasCcbFiltered.every(
    (document) => document?.signatureInfo?.ccbInfo?.data
  );

  if (hasCcb) {
    try {
      const documentsLocalSigned = await signDocumentsCertificate(
        certificateId,
        batch
      );

      return documentsLocalSigned;
    } catch (error) {
      processError(error, setError);
    }
  }
};
